import { render } from "./DepositWebsiteMalawi.vue?vue&type=template&id=443e7cb6&scoped=true"
import script from "./DepositWebsiteMalawi.vue?vue&type=script&lang=js"
export * from "./DepositWebsiteMalawi.vue?vue&type=script&lang=js"

import "./DepositWebsiteMalawi.vue?vue&type=style&index=0&id=443e7cb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-443e7cb6"]])

export default __exports__